module.exports = __webpack_public_path__ + "static/media/repl-icon.66e6fcee.png";